import { currentBrick, slatHeightInCm, slatPercentOfRail } from 'helpers/globals';
import { cmToPx, heightInCm } from 'helpers/utils';
import FenceElementActions from '../FenceElementActions/FenceElementActions';
import FenceElementRail from './FenceElementRail';
import FenceElementDoor from './FenceElementDoor';
import FenceElementWall from './FenceElementWall';
import style from './FenceElement.module.scss';

const FenceElement = ({
  element,
  className = '',
  prevElement,
  nextElement,
  maxSlope,
  color = '',
  railDirection = '',
  railColor = '',
  editable = false,
}) => {
  const getRailsHeight = () => {
    let adjacentTotalHeight;
    let elementFundamentHeight = 0;
    let shortestAdjacent;

    switch (element.shortestAdjacentIndex) {
      case -1:
        shortestAdjacent = prevElement;
        break;
      case 1:
        shortestAdjacent = nextElement;
        break;
      default:
        shortestAdjacent = element;
        break;
    }

    if (!shortestAdjacent.brickCountVertically) {
      return 0;
    }

    adjacentTotalHeight = heightInCm(shortestAdjacent.brickCountVertically + shortestAdjacent.elevation);
    elementFundamentHeight = heightInCm(element.elevation);

    if (element.name === 'fundament') {
      elementFundamentHeight =
        heightInCm(element.elevation + element.brickCountVertically) + currentBrick.topCover.height;
    }

    if (element.name === 'door') {
      elementFundamentHeight = maxSlope - element.start.y;
    }

    return cmToPx(adjacentTotalHeight - elementFundamentHeight);
  };

  const getElementElevation = () => {
    return element.name === 'door' ? cmToPx(maxSlope - element.start.y) : cmToPx(heightInCm(element.elevation));
  };

  const getSlats = () => {
    const railsHeight = railDirection === 'horizontal' ? getRailsHeight() : element.width;
    const totalSlat = railsHeight / (100 / slatPercentOfRail);
    const count = Math.round(totalSlat / cmToPx(slatHeightInCm));

    return {
      count: count > 0 ? count : 2,
      size: cmToPx(slatHeightInCm),
      railDirection,
      railColor,
      railHeight: count > 0 ? getRailsHeight() : slatHeightInCm * 3.5,
    };
  };

  const getActionButtonsMode = () => {
    const compactUnderPxWithAdjacent = 240;
    const compactUnderPxSingle = 90;
    let mode = 'default';
    let prevWidth = prevElement ? prevElement.width : 0;
    let nextWidth = nextElement ? nextElement.width : 0;

    if (
      prevElement &&
      prevElement.name === 'column' &&
      element.name === 'column' &&
      prevWidth + element.width <= compactUnderPxWithAdjacent
    ) {
      mode = 'toggle';
    }

    if (
      nextElement &&
      nextElement.name === 'column' &&
      element.name === 'column' &&
      nextWidth + element.width <= compactUnderPxWithAdjacent
    ) {
      mode = 'toggle';
    }

    if (element.name !== 'column' && element.width <= compactUnderPxSingle) {
      mode = 'toggle';
    }

    return mode;
  };

  return (
    <>
      <div
        key={element.id}
        className={`
          ${style.element}
          ${element.name === 'column' ? style['element-' + element.name] : ''}
          ${style['element-' + color]}
          ${style['element-' + railDirection]}
          ${className}`}
        style={{
          width: cmToPx(element.width),
          paddingBottom: getElementElevation(),
        }}
      >
        {element.name === 'fundament' && <FenceElementRail slats={getSlats()} />}
        {element.name === 'door' && <FenceElementDoor element={element} slats={getSlats()} />}
        {(element.name === 'fundament' || element.name === 'column') && <FenceElementWall element={element} />}
        <div className={style.ruler}>
          <span>{element.width} cm</span>
        </div>
        {editable && <FenceElementActions id={element.id} className={style.buttons} mode={getActionButtonsMode()} />}
      </div>
    </>
  );
};

export default FenceElement;
